<template>
    <div class="dashboard">
    <div class="container-fluid pt-3 pb-3 pl-3 pr-3" style="background-color:#ffffff;">
        <div class="container">
            <div class="row">
                <div class="col-6 pt-3">
                    <h2>B-e Box, La boîte à outils bien-être</h2>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row mt-4">
            <a class="backbutton" href="/bebox/">Retour aux programmes</a>
        </div>
        <div class="row">
            <div class="col-12">
                <h1 class="mt-4 mb-5">Gérer une situation stressante, apports des neurosciences</h1>
            </div>
        </div>
        <div class="row mb-5">
            <div class="col-md-6 col-12">
                <div class="embed-container">
                <iframe src="https://player.vimeo.com/video/521820466/"  frameborder="0" allowfullscreen></iframe>
                </div>
            </div>
            <div class="col-md-6 col-12 ">
                        <h2 class="mt-5">Micro-learning</h2>
                        <p>
                            Découvrez la capsule de micro learning pour mieux connaitre le fonctionnement du cerveau et appréhender le stress.
                            L’apport des neurosciences nous ouvre une compréhension des mécanismes à l’œuvre et nous propose des clés pour mettre en place des stratégies adaptées.
                            Cliquez ici
                        </p>
               
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-12">
                <img :src="require('@/assets/bebox_illu.png')" style="width:100%"/>
            </div>
            <div class="col-md-6 col-12">
                <h2 class="mt-5">Apports techniques</h2>
                <p>
                    Mobiliser vos potentiels grâce aux fiches explicatives de techniques appropriées et facilement intégrables au quotidien.
                    Plusieurs clés techniques pour vous aider à trouver celle qui vous conviendra le mieux.
                    <a class="download mt-4" href="/manage_stress.pdf" target="_blank">Télécharger le pdf</a>
                </p>
            </div>
        </div>
        <div class="row mt-5 mb-5">
            <div class="col-12">
                <h2>Séances immersives</h2>
                <p>Il est maintenant l’heure de passer à la pratique. Voici, 2 séances visitant 2 approches différentes et complémentaires pour expérimenter concrètement leur efficacité. La pratique régulière de ces séances vous permettra d’installer le processus d’acquisition.</p>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-md-6 col-12">
                <h3>Relaxation Stratégique</h3>
                <div class="embed-container">
                 <iframe src="https://player.vimeo.com/video/519415491/"  frameborder="0" allowfullscreen></iframe>
                </div>
            </div>
            <div class="col-md-6 col-12">
                <h3>Faire monter un état positif et porteur à la conscience</h3>
                <div class="embed-container">
                    <iframe src="https://player.vimeo.com/video/519440578/" width="100%" height="360" frameborder="0" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<style>
    h1{
        font-style: normal;
        font-weight: 500;
        font-size: 29px;
        line-height: 24px;
        /* identical to box height, or 83% */
        color: #21212B;
    }
    h2{
        font-style: normal;
        font-weight: 500;
        font-size: 25px;
        line-height: 24px;
        /* identical to box height, or 96% */
    
    
        color: #000000;
    }
    h3{
        font-style: normal;
        font-weight: 500;
        font-size: 21px;
        line-height: 24px;
        /* identical to box height, or 114% */
          color: #000000;
    }
    p {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 23px;
        /* or 147% */
    
    
        color: #000000;
    }
    .embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; }
    .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }
    
    a.download{
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        /* identical to box height, or 150% */
        display: flex;
        align-items: center;
        text-align: center;
        color: #FDB72E;
        background-color:#ffffff;
        padding:5px;
        display:block;
        width:150px;
        border-radius:5px;
        border:1px solid #FDB72E;
    }
    .backbutton{
        color:#000000;
        text-decoration:underline;
    }
</style>

<script>
    import HomeItem from '../components/BeboxItem'
    import { mapState } from 'vuex';
    export default {
        name: 'dashboard',
        components: { HomeItem },
        computed: mapState({ user: state => state.user.user }),
        data() {
        },
        layout(context) {
            return 'layout'
        },
        methods: {
        },
    };
</script>
